// c:\Users\saoma\dev\house-planner\frontend\src\components\FloorPlanner.jsx
import React from "react";
import { Stage, Layer, Line } from "react-konva";
import RoomCanvas from "./RoomCanvas";

// --- 定数定義 ---
const FIXED_STAGE_WIDTH = 1000; // 固定のステージ幅
const FIXED_STAGE_HEIGHT = 800; // 固定のステージ高さ
const GRID_SNAP_SIZE = 25; // Room.jsx で使われている
const GRID_LINE_SIZE = 50; // グリッド線の間隔

// グリッド線を描画する関数 (サイズを引数で受け取る)
const drawGrid = (width, height, gridSize) => {
  const lines = [];
  if (width <= 0 || height <= 0) return lines;

  // 垂直線
  for (let i = 0; i < width / gridSize; i++) {
    lines.push(
      <Line
        key={`v-${i}`}
        points={[
          Math.round(i * gridSize) + 0.5,
          0,
          Math.round(i * gridSize) + 0.5,
          height,
        ]}
        stroke="#eee" // グリッド線を少し薄く
        strokeWidth={1}
        listening={false}
      />
    );
  }
  // 水平線
  for (let j = 0; j < height / gridSize; j++) {
    lines.push(
      <Line
        key={`h-${j}`}
        points={[
          0,
          Math.round(j * gridSize) + 0.5,
          width,
          Math.round(j * gridSize) + 0.5,
        ]}
        stroke="#eee" // グリッド線を少し薄く
        strokeWidth={1}
        listening={false}
      />
    );
  }
  return lines;
};

const FloorPlanner = React.forwardRef(({
  rooms,
  setRooms,
  selectedId,
  setSelectedId,
}, ref) => {
  const stageRef = React.useRef(null);
  // ★ containerRef, stageSize state, useEffect を削除

  // ★ グリッド線を固定サイズで生成
  const gridLines = drawGrid(
    FIXED_STAGE_WIDTH,
    FIXED_STAGE_HEIGHT,
    GRID_LINE_SIZE
  );

  // 間取り画像をキャプチャする関数
  const captureFloorPlanImage = React.useCallback(() => {
    if (stageRef.current) {
      const dataURL = stageRef.current.toDataURL({
        mimeType: 'image/png',
        quality: 1.0,
        pixelRatio: 1
      });
      return dataURL;
    }
    return null;
  }, []);

  // 親コンポーネントがキャプチャ関数にアクセスできるようにする
  React.useImperativeHandle(ref, () => ({
    captureImage: captureFloorPlanImage
  }), [captureFloorPlanImage]);

  // ステージクリック処理 (変更なし)
  const handleStageClick = (e) => {
    if (e.target === e.target.getStage()) {
      setSelectedId(null);
      return;
    }
    const clickedOnTransformer =
      e.target.getParent()?.className === "Transformer";
    if (clickedOnTransformer) {
      return;
    }
    // Room の Group には name を設定していないので、図形以外をクリックしたら解除
    const className = e.target.getClassName(); // Rect や Text かどうか
    if (className !== "Rect" && className !== "Text") {
      // Transformer のハンドル部分も除外 (より確実に)
      if (
        !e.target.getParent() ||
        e.target.getParent().getClassName() !== "Transformer"
      ) {
        setSelectedId(null);
      }
    }
  };

  return (
    // 親divのスタイルから width と border を削除
    <div
      style={{
        flex: 1, // 親のflexコンテナ内で可能な限り広がる
        overflow: "hidden", // Stageがはみ出た部分を隠す
        backgroundColor: "#f8f8f8", // 背景色を少し変更
        position: "relative", // 必要に応じて追加 (他の要素との重なり順など)
      }}
      // ref={containerRef} は不要になったので削除
    >
      <Stage
        width={FIXED_STAGE_WIDTH} // ★ 固定幅を設定
        height={FIXED_STAGE_HEIGHT} // ★ 固定高さを設定
        ref={stageRef}
        onClick={handleStageClick}
        onTap={handleStageClick}
        // draggable // ★ 将来的にステージ全体をドラッグ可能にする場合
      >
        {/* グリッド線レイヤー */}
        <Layer listening={false}>{gridLines}</Layer>


        {/* 部屋描画レイヤー */}
        <Layer>
          <RoomCanvas
            rooms={rooms}
            setRooms={setRooms}
            selectedId={selectedId}
            setSelectedId={setSelectedId}
            // gridSnapSize は RoomCanvas では使われていないので削除
          />
        </Layer>
      </Stage>
    </div>
  );
});

export default FloorPlanner;
